export default "__VITE_ASSET__D$keYHpy__"